import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SearchInput from './SearchInput';
import Heading1 from '../common/Heading1';
import ReturnsSidePanel from './returns/ReturnsSidePanel';
import ParcelFinderSwitch from './ParcelFinderSwitch';
import {
  parcelFinderSearch,
  setSearchQuery,
  setSearchType,
  clearSearch,
  parcelFinderReload,
} from '../../reducers/parcelFinderReducer';
import { getReturningOrderId } from '../../selectors/parcelFinderReturnsSelectors';
import { cancelReturn, initReturn } from '../../reducers/parcelFinderReturnsReducer';
import Locale from '../Translate/Locale';
import useSearchParam from './useSearchParam';
import useModal from '../modal/useModal';
import SubmitClaimPanel from '../claims-center/submit-claims/SubmitClaimPanel';

import './ParcelFinder.scss';

function ParcelFinder(props) {
  const {
    onSearch,
    reloadSearch,
    setSearchQuery,
    setSearchType,
    searchType,
    clearSearch,
    isLoading,
    loaded,
    results,
    createReturn,
    returningOrderId,
    cancelReturn,
  } = props;

  const [query, setQuery] = useSearchParam('query');
  const [shipmentToClaim, claimShipment, cancelClaim] = useModal(null);

  useEffect(() => {
    setSearchQuery(query);
    onSearch();
  }, []);

  const onSetSearchQuery = (searchQuery) => {
    setQuery(searchQuery);
    setSearchQuery(searchQuery);
  };

  const onClearSearch = () => {
    setQuery('');
    clearSearch();
  };

  const onSetSearchType = (searchType) => {
    setQuery('');
    setSearchType(searchType);
  };

  return (
    <>
      <div styleName="container">
        <div styleName="search-header">
          <Heading1 styleName="title">Find a parcel by:</Heading1>
          <div styleName="input">
            <SearchInput
              searchType={searchType}
              value={query}
              onChangeType={onSetSearchType}
              onChange={onSetSearchQuery}
              onClear={onClearSearch}
              onSearch={onSearch}
            />
          </div>
          <div styleName="search-limit-notice">
            <Locale>PARCEL_FINDER_SEARCH_LIMIT_NOTICE</Locale>
          </div>
        </div>
        <div styleName="search-result">
          <ParcelFinderSwitch
            isLoading={isLoading}
            loaded={loaded}
            results={results}
            onClaimShipment={claimShipment}
            onCreateReturn={createReturn}
            reloadSearch={reloadSearch}
          />
        </div>
      </div>
      <SubmitClaimPanel
        entryPoint="parcel-finder"
        isOpen={!!shipmentToClaim}
        shipment={shipmentToClaim}
        onClose={cancelClaim}
        onClaimSubmitted={reloadSearch}
      />
      <ReturnsSidePanel isOpen={!!returningOrderId} onClose={cancelReturn} />
    </>
  );
}

ParcelFinder.propTypes = {
  onSearch: PropTypes.func,
  claimShipment: PropTypes.func,
  cancelClaim: PropTypes.func,
};

ParcelFinder.defaultProps = {
  onSearch: () => {},
  resetSearch: () => {},
};

function mapStateToProps(state) {
  const { isLoading, loaded, results, searchType } = state.parcelFinder;

  return {
    returningOrderId: getReturningOrderId(state),
    isLoading,
    loaded,
    results,
    searchType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSearch: () => dispatch(parcelFinderSearch()),
    reloadSearch: () => dispatch(parcelFinderReload()),
    setSearchQuery: (searchQuery) => dispatch(setSearchQuery(searchQuery)),
    setSearchType: (searchType) => dispatch(setSearchType(searchType)),
    clearSearch: () => dispatch(clearSearch()),
    createReturn: (order) => dispatch(initReturn(order)),
    cancelReturn: () => dispatch(cancelReturn()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ParcelFinder);
